const TimeHelpers = {}

TimeHelpers.isCurrentDate = (time) => {
  const dateTime = new Date(Number(time))
  const now = new Date()
  if (now.getDate() !== dateTime.getDate() || now.getMonth() !== dateTime.getMonth() || now.getFullYear() !== dateTime.getFullYear()) {
    return false
  }
  return true
}

TimeHelpers.isPreviouDate = (time) => {
  const dateTime = new Date(Number(time))
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  if (yesterday.getDate() !== dateTime.getDate() || yesterday.getMonth() !== dateTime.getMonth() || yesterday.getFullYear() !== dateTime.getFullYear()) {
    return false
  }
  return true
}

TimeHelpers.isCurrentYear = (time) => {
  const dateTime = new Date(Number(time))
  const now = new Date()
  if (now.getFullYear() !== dateTime.getFullYear()) {
    return false
  }
  return true
}

TimeHelpers.getHHmm24 = (time, spliter = ':') => {
  const dateTime = new Date(Number(time))
  const dateHour = dateTime.getHours()
  const dateMinute = dateTime.getMinutes()
  const timeHour = dateHour < 10 ? `0${dateHour}` : dateHour
  const timeMinute = dateMinute < 10 ? `0${dateMinute}` : dateMinute
  return `${timeHour}${spliter}${timeMinute}`
}

TimeHelpers.getHHmm12 = (time, spliter = ':') => {
  const dateTime = new Date(Number(time))
  let dateHour = dateTime.getHours()
  if (dateHour > 12) dateHour -= 12
  const dateMinute = dateTime.getMinutes()
  const timeHour = dateHour < 10 ? `0${dateHour}` : dateHour
  const timeMinute = dateMinute < 10 ? `0${dateMinute}` : dateMinute
  return `${timeHour}${spliter}${timeMinute}`
}

TimeHelpers.getDDMM = (time, spliter = '/') => {
  const dateTime = new Date(Number(time))
  const dateDate = dateTime.getDate()
  const dateMonth = dateTime.getMonth() + 1
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = dateDate < 10 ? `0${dateDate}` : dateDate
  return `${timeDate}${spliter}${timeMonth}`
}

TimeHelpers.getDDMMYY = (time, spliter = '/') => {
  const dateTime = new Date(Number(time))
  const dateDate = dateTime.getDate()
  const dateMonth = dateTime.getMonth() + 1
  const dateYear = String(dateTime.getFullYear()).substring(2)
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = dateDate < 10 ? `0${dateDate}` : dateDate
  return `${timeDate}${spliter}${timeMonth}${spliter}${dateYear}`
}

TimeHelpers.getDDMMYYYY = (time, spliter = '/') => {
  const dateTime = new Date(Number(time))
  const dateDate = dateTime.getDate()
  const dateMonth = dateTime.getMonth() + 1
  const dateYear = String(dateTime.getFullYear())
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = dateDate < 10 ? `0${dateDate}` : dateDate
  return `${timeDate}${spliter}${timeMonth}${spliter}${dateYear}`
}

TimeHelpers.convertDDMMYYYYHHmmssFormat = (time) => {
  if (!time) return ''
  const dateMonth = time.getMonth() + 1
  const timeYear = time.getFullYear()
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
  const timeHour = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
  const timeMinute = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()
  const timeSecond = time.getSeconds() < 10 ? `0${time.getSeconds()}` : time.getSeconds()
  return `${timeDate}${timeMonth}${timeYear}_${timeHour}${timeMinute}${timeSecond}`
}

TimeHelpers.convertDDMMYYYYHHmmFormat = (time, dateSpliter, dateTimeSpliter) => {
  if (!time) return ''
  const dateMonth = time.getMonth() + 1
  const timeYear = time.getFullYear()
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
  const timeHour = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
  const timeMinute = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()
  return `${timeDate}${dateSpliter}${timeMonth}${dateSpliter}${timeYear} ${dateTimeSpliter} ${timeHour}:${timeMinute}`
}

TimeHelpers.convertHHmmDDMMYYYYFormat = (time, dateSpliter, dateTimeSpliter) => {
  if (!time) return ''
  const dateMonth = time.getMonth() + 1
  const timeYear = time.getFullYear()
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
  const timeHour = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
  const timeMinute = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()
  return `${timeHour}:${timeMinute} ${dateTimeSpliter} ${timeDate}${dateSpliter}${timeMonth}${dateSpliter}${timeYear}`
}

TimeHelpers.convertYYYYMMDDHHmmssFormat = (time) => {
  const dateMonth = time.getMonth() + 1
  const timeYear = time.getFullYear()
  const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
  const timeDate = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
  const timeHour = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
  const timeMinute = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()
  const timeSecond = time.getSeconds() < 10 ? `0${time.getSeconds()}` : time.getSeconds()
  return `${timeYear}${timeMonth}${timeDate}_${timeHour}${timeMinute}${timeSecond}`
}

TimeHelpers.getCurrentDateTime = () => {
  const now = new Date();
  
  // Lấy các giá trị ngày, tháng, năm, giờ, phút, giây và mili-giây
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  const second = String(now.getSeconds()).padStart(2, '0');
  const millisecond = String(now.getMilliseconds()).padStart(3, '0');

  // Tạo chuỗi kết quả theo định dạng yyyy-MM-dd HH:mm:ss,sss
  const formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second},${millisecond}`;

  return formattedDateTime;
}

TimeHelpers.convertDateFormat = (time) => {
  try {
    if (isCurrentDate(time)) {
      return 'today'
    }
    if (isPreviouDate(time)) {
      return 'yesterday'
    }
    const dateMonth = time.getMonth() + 1
    const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
    const timeDate = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
    if (isCurrentYear(time)) {
      return `${timeDate}/${timeMonth}`
    }
    const timeYear = time.getFullYear()
    return `${timeDate}/${timeMonth}/${timeYear}`
  } catch (err) {
    return ''
  }
}


export default TimeHelpers